import React, { useMemo } from "react";
import { Bill } from "@common/types/bill";
import { usePatchImporterBills } from "@api/bill.api";
import { AccrualImporterDrawer } from "@components/accrualImporter/AccrualImporterDrawer";
import { mapBillsToImporterRows } from "@components/accrualImporter/mapAccrualsToImporterRows";
import { useAccrualEditSubmit } from "@components/accrualImporter/useAccrualEditSubmit";

interface Props {
    bills: Bill[];
    open?: boolean;
    onClose: () => void;
}

export const ManualBillEditDrawer: React.FC<Props> = ({
    bills,
    open,
    onClose,
}) => {
    const patchBills = usePatchImporterBills();
    const initialRows = useMemo(() => mapBillsToImporterRows(bills), [bills]);
    const originalAccrualIds = useMemo(() => bills.map((b) => b.id), [bills]);

    const handleSubmit = useAccrualEditSubmit({
        mode: "bill",
        originalAccrualIds,
        mutateAsync: patchBills.mutateAsync as (
            params: Record<string, unknown>,
        ) => Promise<unknown>,
        onClose,
        successMessage: "Bills updated",
        errorMessage: "Failed to update bills",
    });

    return (
        <AccrualImporterDrawer
            mode="bill"
            open={open}
            onClose={onClose}
            onSubmit={handleSubmit}
            isSubmitting={patchBills.isPending}
            initialRows={initialRows}
            title="Edit bills"
        />
    );
};
